import {
  UseFormRegister,
  UseFormWatch,
  UseFormSetValue,
  FieldErrors,
} from "react-hook-form";
import Input from "../../../../../shared/components/UI/Input";
import Select from "../../../../../shared/components/UI/Select";
import ButtonSave from "../components/ButtonSave";
import { RegionType } from "../useUserProfile";
import ErrorWrap from "../components/ErrorWrap";

interface Props {
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  regions: RegionType[];
  hasUnsavedChanges: boolean;
  errors: FieldErrors;
}

export default function BasicInfo({
  register,
  watch,
  setValue,
  regions,
  hasUnsavedChanges,
  errors,
}: Props) {
  const regionName = watch("region_name");
  const experience = watch("experience");

  return (
    <>
      <div className="cabinet_profileeditmodal-right-content">
        <div className="cabinet_profileeditmodal-right-content-text">
          <div className="cabinet_profileeditmodal-right-content-text-title">
            Основная информация
          </div>
          <div className="cabinet_profileeditmodal-right-content-text-description">
            Расскажите о себе
          </div>
        </div>
        <Input
          type="text"
          grayStyle
          placeholder="Позывной"
          className="cabinet_profileeditmodal-right-content-name"
          {...register("user_callsign")}
        />
        <textarea
          placeholder="О себе"
          className="cabinet_profileeditmodal-right-content-about"
          {...register("about")}
        />
        <Select
          options={regions.map((r) => r.name)}
          value={regionName}
          isChangeable
          classes={{
            select_wrapper: "cabinet_profileeditmodal-right-content-region",
            select_option:
              "cabinet_profileeditmodal-right-content-region-option",
            select_placeholder:
              "cabinet_profileeditmodal-right-content-region-placeholder",
          }}
          placeholder="Регион"
          setValue={setValue}
          formName="region_name"
        />
        <ErrorWrap>
          <Select
            options={Array.from(
              { length: 2025 - 1995 + 1 },
              (_, i) => 1995 + i
            )}
            value={experience}
            isChangeable
            placeholder="Игровой стаж"
            setValue={setValue}
            formName="experience"
            classes={{
              select_wrapper: "cabinet_profileeditmodal-right-content-region",
              select_option:
                "cabinet_profileeditmodal-right-content-region-option",
              select_placeholder:
                "cabinet_profileeditmodal-right-content-region-placeholder",
            }}
          />
        </ErrorWrap>
      </div>
      <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
    </>
  );
}
